import React from "react";
import {KTMScreen} from "ktm-ui";
import toastr from "toastr";
import Moment from "react-moment";
import {
    Button,
    Modal,
} from "react-bootstrap";
import PagedHistory from "components/PagedHistory";

const REF_NO_MAX_LENGTH = 30;

const formatMoney = (value: number) =>
    value.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2});

export default KTMScreen(
    {name: "fundingrefund"},
    class extends React.Component<any, any> {
        state = {
            loading: true,
            success: false,
            searchInput: "",
            searchResult: null,
            amount: "",
            refNo: "",
            pageSize: 5,
            currentPage: 1,
            showRefundModal: false
        };

        componentDidMount() {
        }

        submitSearch = () => {
            if (this.state.searchInput != null && this.state.searchInput.trim() !== "") {
                fetch("/api/payment/searchrefund/" + encodeURIComponent(this.state.searchInput.trim()), {
                    method: "GET",
                })
                    .then((response) => response.json())
                    .then((data) => {
                        this.setState(
                            {
                                searchResult: data,
                                loading: false,
                                success: data.success,
                                amount: "",
                                refNo: "",
                                currentPage: 1,
                            },
                            () => {
                                if (!this.state.success) {
                                    toastr.error("Policy not found", "Error");
                                }
                            }
                        );
                    })
                    .catch((error) => {
                        this.setState({searchResult: null, success: false});
                        toastr.error("Search failed", "Error");
                    });
            }
        };

        handleCloseRefundModal = () => {
            this.setState({showRefundModal: false});
        };

        handleSubmitRefundModal = () => {
            this.submitRefund();
            this.setState({showRefundModal: false});
        };

        verifyFunding = () => {
            this.setState({showRefundModal: true});
        };
        submitRefund = () => {
            const amountValue = parseFloat(this.state.amount);
            if (!Number.isFinite(amountValue) || amountValue <= 0) {
                toastr.error("Invalid amount", "Error");
                return;
            }
            const refNo = this.state.refNo.trim();
            fetch("/api/payment/setrefund", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    policyId: this.state.searchResult.policyId,
                    amount: amountValue,
                    refNo: refNo === "" ? null : refNo,
                }),
            })
                .then(async (response) => {
                    const text = await response.text();
                    let data: any = null;
                    try {
                        data = text ? JSON.parse(text) : null;
                    } catch {
                        data = text;
                    }
                    if (!response.ok) {
                        const message =
                            (data && data.message) ||
                            (typeof data === "string" && data.length > 0 ? data : null) ||
                            "Submission failed";
                        toastr.error(message, "Error");
                        return null;
                    }
                    return data;
                })
                .then((data) => {
                    if (!data) {
                        return;
                    }
                    this.setState(
                        {
                            searchResult: data,
                            loading: false,
                            success: data.success,
                            amount: "",
                            refNo: "",
                            currentPage: 1,
                        },
                        () => {
                            if (!this.state.success) {
                                toastr.error("Failed to submit", "Error");
                            }
                        }
                    );
                })
                .catch((error) => {
                    toastr.error("Submission failed", "Error");
                });
        };

        setInput = (e) => {
            this.setState({searchInput: e.target.value});
        };
        setAmount = (e) => {
            this.setState({amount: e.target.value});
        };
        setRefNo = (e) => {
            this.setState({refNo: e.target.value});
        };
        setPage = (page: number) => {
            this.setState({currentPage: page});
        };
        setPageSize = (size: number) => {
            this.setState({pageSize: size, currentPage: 1});
        };

        handleKeyDown = (event) => {
            if (event.key === "Enter") {
                this.submitSearch();
            }
        };

        downloadCheque = (refundId) => {
            fetch(`/api/payment/getchqrefund?refundId=${refundId}`, {
                method: "GET",
            })
                .then((response) => response.blob())
                .then((blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `CHQ_${new Date().toLocaleDateString()}.pdf`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        renderRefundTable = (entries) => (
            <table className="table">
                <thead>
                <tr>
                    <td>Type</td>
                    <td>Cheque No.</td>
                    <td>Ref No. / Note</td>
                    <td style={{textAlign: "right"}}>Amount</td>
                    <td>Date</td>
                    <td></td>
                </tr>
                </thead>
                <tbody>
                {entries.map((data) => (
                    <tr key={data.id}>
                        <td>Cheque</td>
                        <td>{data.chqNo}</td>
                        <td>{data.notes}</td>
                        <td style={{textAlign: "right"}}>{formatMoney(data.amount)}</td>
                        <td>
                            <Moment local format="YYYY-MM-DD">
                                {data.transDate}
                            </Moment>
                        </td>
                        <td>
                            <button className={"btn btn-primary me-2"} onClick={() => this.downloadCheque(data.id)}>
                                Download
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        );

        render() {
            let responseContents = null;

            let fundingModal = <Modal show={this.state.showRefundModal} onHide={this.handleCloseRefundModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Submit Refund</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to submit this funding refund?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseRefundModal}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={this.handleSubmitRefundModal}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>

            if (this.state.searchResult != null && this.state.success) {
                const result = this.state.searchResult;
                const refunds = result.ledgerEntries || [];
                const amountValue = parseFloat(this.state.amount);

                responseContents = (
                    <div>
                        <div className="ktm-funding-header">
                            <div className="ktm-funding-name">
                                {result.policyName}
                            </div>
                            <div className="ktm-funding-meta">
                                <span>Policy No. {result.policyNumber}</span>
                                <span>Account No. {result.spendingAccountNumber ?? "—"}</span>
                            </div>
                        </div>
                        <div className="ktm-funding-balance-label">
                            Current Balance:{" "}
                            <div className="ktm-funding-balance">
                                ${formatMoney(result.currentBalance)}
                            </div>
                        </div>
                        <div className="ktm-funding-form">
                            <div className="ktm-funding-form-title">Submit Refund</div>
                            <div className="input-group">
                                <span className="input-group-text">$</span>
                                <input
                                    className="form-control"
                                    type="number"
                                    inputMode="decimal"
                                    step="0.01"
                                    onChange={(e) => this.setAmount(e)}
                                    value={this.state.amount}
                                    placeholder="Amount"
                                    onKeyPress={(e) => {
                                        const keyCode = e.keyCode || e.which;
                                        const keyValue = String.fromCharCode(keyCode);
                                        const validCharRegex = /[0-9.]/;
                                        if (!validCharRegex.test(keyValue)) {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                            </div>
                            <input
                                className="form-control"
                                onChange={(e) => this.setRefNo(e)}
                                value={this.state.refNo}
                                placeholder="Ref No. (optional, e.g. ticket #)"
                                maxLength={REF_NO_MAX_LENGTH}
                            />
                            <button
                                onClick={() => this.verifyFunding()}
                                className="btn btn-primary"
                                type="button"
                                disabled={!Number.isFinite(amountValue) || amountValue <= 0}
                            >
                                Submit
                            </button>
                        </div>
                        <PagedHistory
                            title="Refund History"
                            items={refunds}
                            pageSize={this.state.pageSize}
                            currentPage={this.state.currentPage}
                            onPageChange={this.setPage}
                            onPageSizeChange={this.setPageSize}
                            renderTable={this.renderRefundTable}
                        />
                    </div>
                );
            }
            return (
                <div className="ktm-financials-content">
                    <div className="ktm-finance-search">
                        <input
                            onKeyDown={this.handleKeyDown}
                            type="text"
                            className="form-control"
                            name="searchInput"
                            onChange={(e) => this.setInput(e)}
                            value={this.state.searchInput}
                            placeholder={
                                "Enter policy name, policy number, or account number"
                            }
                        />
                        <button
                            onClick={() => this.submitSearch()}
                            className="btn btn-outline-primary"
                            type="button"
                        >
                            Search
                        </button>
                    </div>
                    {responseContents}
                    {fundingModal}
                </div>
            );
        }
    }
);
